/* APP ENDPOINTS DEV */
const app_dev = 'https://api.smdigital.pe/stg/v2/pe';
const app_key_val = '4gKPRDybsgiMQIqkQDJYW7ZulPocTci8';
const app_env = 'metro/wc';
//const app_env = 'metro';

/* MIDDLEWARE ENDPOINTS DEV */
const middle_dev = 'https://api.smdigital.pe/prod/v1';
const middle_key_val = 'GYzV9MJ89JLI5kQcIxLQOYaKpg4qqd7q';
const middle_env = 'METRO';
//const middle_env = 'metro/wc';
/*CONTROLLERS */
//const couponsWeb_controller = 'coupons_web'; //local
const couponsWeb_controller = 'webcoupons'; //DEV
const kiosko_controller = 'kiosko_platform'; //local



/* PATH SESSION DASHBOARD */
const path_dashboard = '/home';

/* VERSION */
const versionstr = 'v.1.1.1-alpha';

/* MODE APP */
const environment = 'production';

/* DOCUMENT TYPES */
const documentTypes = [
    {cod: 0, title:'OTROS'},
    {cod: 1, title:'DNI'},
    {cod: 2, title:'C.ID'},
    {cod: 3, title:'C.EXT'},
    {cod: 4, title:'PASS'},
    {cod: 5, title:'RUC'},
    {cod: 9, title:'SIN DOC-ID'}
];

/* SOCIAL AUTH */
const social_auth = {
    facebook_id: '1731466677050479', 
    google_id: '689450970879-tmlo43s2tcq5p24dj98m1ec9a21tkddh.apps.googleusercontent.com'

};

/* PASSWORD AUTH */
const password_auth = {
    is_active: false, 
    redirect_to: 'https://www.metro.pe/', 
    authorization: ['$kiosko24']
};
/*Maintenance */
const maintenance ={
     is_active: false
     
 };

/* RECAPTCHA */
const recaptcha = {
    platform: '2',
    site_key: '6LeUQDkeAAAAAL3dKObp6eGaPiATBLJfzyVosRWC',
    action_register: 'register',
    action_recovery: 'recovery'    
};

/* MENU LINKS */
const main_links = {
    main: '/', 
    login: '/login', 
    forgot_pass: '/lost-password', 
    register: '/register', 
    logout: '/logout',
    main_logged: '/home', 
    contact: '#', 
    cart: '/account-coupons', 
    checkout: '/account-coupons-change/:id', 
    search: '#', 
    my_account: '/account/my-account', 
    my_coupons: '/account/my-coupons', 
    terms_cond: '/account/terms', 
    privacy: '/account/privacy',
    cookies: '/account/cookies',
    data_protection: '/account/data-protection',
};
const qr_links={
    my_coupons_qr_public:'/my-coupons/qr/',
    terms_condition_public: '/terms_condition-public/qr/',
    privacy_public: '/privacy-public/qr/',
    data_protecction_public: '/data_protection-public/qr/',
    cookies_public:'/cookies-public/qr/'
};
const social_links = {
    facebook: 'https://www.facebook.com/metroperu', 
    twitter: 'https://twitter.com/metroperu', 
    youtube: 'https://www.youtube.com/user/MetroPeru', 
    instagram: 'https://www.instagram.com/metro_peru/?igsh=NXZ5ZDdjN3ZlZ2s4'
};
const app_links = {
    call_center: 'tel:+5116138888',
    libro_reclamaciones: 'https://librorec.metro.pe/frmLRRegistro.aspx?str=OGEieQOqs0PLR5ZMO3i0lUk5Eq6GcJnKSddcDSXUyjw=', 
    reporte_sostenibilidad: 'https://www.metro.pe/institucional/reporte-sostenibilidad/', 
    politicas: 'https://www.metro.pe/institucional/politicas-privacidad-seguridad', 
    politicas_cookies: 'https://www.metro.pe/institucional/politicas-privacidad-seguridad#tabs-2',
    data_protection_format:'https://api.test.smdigital.pe/endpoint/imgWebCupones/Legal_Metro.zip',
    frequent_questions: '/frequent-questions',
    frequent_questions_private: '/account-frequent-questions',

};
const footer_links = {
    nosotros: {
        bienvenido: 'https://www.metro.pe/Institucional/bienvenidos', 
        cencosud: 'https://www.metro.pe/Institucional/cencosud', 
        memoria: 'https://www.cencosud.com/cencosud/site/docs/20230413/20230413122347/memoria_integrada_cencosud_vf___completo.pdf' 
   
    }, 
    tienda: {
        beneficios: 'https://www.metro.pe/institucional/beneficios', 
        comprar: 'https://www.metro.pe/institucional/como-comprar', 
        pedidos: 'https://www.metro.pe/pedidos', 
        data_protecction_public: '/data_protection-public',
        privacy_public: '/privacy-public',
        terms_condition_public: '/terms_condition-public',
        preguntas: 'https://www.metro.pe/institucional/preguntas-frecuentes', 
        cookies_public:'/cookies-public',
        legales: 'https://www.metro.pe/legales', 
        covid: 'https://www.metro.pe/medidas-COVID-19'
    }, 
    contacto: {
        tiendas: 'https://www.metro.pe/stores', 
        consultas: 'https://www.metro.pe/consultas-y-sugerencias', 
    }
};

/* CATEGORIES AVAILABLES */
const categories_links = [
    {
        path: '/categories/alimentos', 
        handle: 'alimentos', 
        title: 'Alimentos'
    },
    {
        path: '/categories/bazar', 
        handle: 'bazar', 
        title: 'Bazar'
    },
    {
        path: '/categories/beb-s-ni-os-y-jugueter-a', 
        handle: 'beb-s-ni-os-y-jugueter-a', 
        title: 'Bebés, niños y juguetería'
    },
    {
        path: '/categories/bebidas', 
        handle: 'bebidas', 
        title: 'Bebidas'
    },
    {
        path: '/categories/cuidado-del-hogar', 
        handle: 'cuidado-del-hogar', 
        title: 'Cuidado del hogar'
    },
    {
        path: '/categories/cuidado-personal', 
        handle: 'cuidado-personal', 
        title: 'Cuidado personal'
    },
    {
        path: '/categories/dia-madre', 
        handle: 'dia-madre', 
        title: 'Especiales'
    },
    {
        path: '/categories/mascotas', 
        handle: 'mascotas', 
        title: 'Mascotas'
    },
    {
        path: '/categories/otros', 
        handle: 'otros', 
        title: 'Otros'
    },
    {
        path: '/categories/vestimenta', 
        handle: 'vestimenta', 
        title: 'Vestimenta'
    },
    {
        path: '/categories/tecnolog-a-y-electrohogar', 
        handle: 'tecnolog-a-y-electrohogar', 
        title: 'Tecnología y electrohogar'
    },
    {
        path: '/categories/todos', 
        handle: 'todos', 
        title: 'Todos'
    },
    {
        path: '/categories/ecommerce', 
        handle: 'ecommerce',
        title: 'Metro.pe'
    },
    {
        path: '/categories/almacenes', 
        handle: 'almacenes',
        title: 'Almacenes'

    }
];

/* CONSTANT STRINGS */
const delete_content_backward = 'deleteContentBackward';

/* CONSTANTS */
const constants = {
    maxBanner: 99,
    includeBonus: false
};

export {
    app_dev,
    app_key_val, 
    app_env, 
    middle_dev, 
    middle_key_val, 
    middle_env, 
    path_dashboard, 
    versionstr, 
    social_links, 
    app_links, 
    footer_links, 
    environment, 
    main_links, 
    documentTypes, 
    social_auth, 
    recaptcha,
    categories_links, 
    password_auth, 
    delete_content_backward,
    maintenance,
    couponsWeb_controller,
    kiosko_controller,
    constants,
    qr_links
};
